import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { installFoilDebugFlags } from './utils/foilDebug'
import { listenForPwaInstall } from './composables/usePwaInstall'
import { watchForNewBuild } from './utils/staleBuild'
import './style.css'

installFoilDebugFlags()
listenForPwaInstall()
watchForNewBuild()

if ('serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js')
}

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate as any)

app.use(pinia)
app.use(router)
app.mount('#app') 